// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w-logo[data-v-b403fa22] {\n  max-height: 50px;\n}\n.w-ext-login-body[data-v-b403fa22] {\n  padding-top: 16%;\n  padding-bottom: 16%;\n}\n.btn-login[data-v-b403fa22] {\n  width: 220px;\n  line-height: 36px;\n  margin: 25px auto;\n}\n.btn-login[data-v-b403fa22]:hover {\n  text-decoration: none;\n  color: #002e6e;\n}\n.oval[data-v-b403fa22] {\n  margin: 15px auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
